<template>
  <v-container>
    <!--app-view-toolbar-->
    <app-view-toolbar :title="title" :showBackButton="true"></app-view-toolbar>
    <template v-if="viewDataIsLoaded">
      <v-form ref="formEdit">
        <v-row>
          <v-col>
            <v-text-field
              type="text"
              label="Namn"
              outlined
              v-model="viewData.qualificationPresetData.name"
              :rules="[formRules.required]"
              validate-on-blur
              required
              maxlength="25"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <!--qualification-form-fields-->
            <app-qualification-form-fields mode="qualificationPreset" :data="viewData.qualificationPresetData"></app-qualification-form-fields>
          </v-col>
        </v-row>
      </v-form>
      <!--app-form-bottom-->
      <app-form-bottom
        :postWasInvalid="postWasInvalid"
        :errorOutput="errorOutput"
        @onSubmit="doSubmit"
        @onErrorOk="postWasInvalid = false"
        :loader="loader"
        :removable="!isNew"
        @onRemoveDialogOpen="removeDialog = true"
        @onRemoveDialogClose="removeDialog = false"
        @onRemove="remove"
        txtAnObject="Chaufförsprofil"
        txtTheObject="Chaufförsprofilen"
        :removeDialog="removeDialog"
      ></app-form-bottom>
    </template>
    <!--snack-bar-->
    <app-snack-bar></app-snack-bar>
  </v-container>
</template>

<script>
import axios from 'axios'
import QualificationFormFields from '../components/QualificationFormFields'
import ViewToolbar from '../components/ViewToolbar'
import FormBottom from '../components/FormBottom'
import SnackBar from '../components/SnackBar'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { snackBarBus } from '../main'

import { mapGetters } from 'vuex'

export default {
  components: {
    'app-snack-bar': SnackBar,
    'app-form-bottom': FormBottom,
    'app-qualification-form-fields': QualificationFormFields,
    'app-view-toolbar': ViewToolbar
  },
  mixins: [generalMixin, urlMixin],
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      viewData: {
        driverData: {
        }
      },
      postWasInvalid: false,
      viewDataIsLoaded: false,
      errorOutput: '',
      removeDialog: false,
      loader: true,
    }
  },
  computed: {
    ...mapGetters(['loggedInData', 'agentData', 'access_token']),
    title() {
      return this.isNew ? "Ny chaufförsprofil" : "Redigera chaufförsprofil"
    },
    isNew() {
      return this.id == 0
    },
  },
  watch: {
    viewDataIsLoaded() {
//      console.log("loaded viewData", this.viewData)
    }
  },
  methods: {
    doSubmit() {
      const formIsValid = this.$refs.formEdit.validate()
      if (!formIsValid) {
        snackBarBus.$emit('message', 'Formuläret ej komplett ifyllt')
        return
      }
      this.loader = true
      //post data to API
      let postData = {
        qualificationPresetData: this.viewData.qualificationPresetData,
        agentData: this.loggedInData.agentData
      }
      //set config for axios request with Authorization header
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let url = this.url_composeApiUrl('/company/qualification-preset/' + this.id)
//      console.log('put url: ' + url, postData)
      axios.put(url, postData, config)
        .then(response => {
//          console.log('put response', response)
          this.loader = false
          if (response.data.success) {
            //success
            //go to qualification preset list
            this.$router.replace({ name: 'qualification-preset' })
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            //still logged in
            this.errorOutput = this.generalParseErrorArray(response.data.returnData.error_ar)
            this.postWasInvalid = true
          }
        })
        .catch(error => {
          this.loader = false
          snackBarBus.$emit('message', error.toString())
          this.postWasInvalid = true
        })
    },
    remove() {
      //hide dialog
      this.removeDialog = false
      //show loader
      this.loader = true
      //set config for axios request with Authorization header
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let url = this.url_composeApiUrl('/company/qualification-preset/' + this.id)
      axios.delete(url, config)
        .then(response => {
//          console.log('delete response', response)
          this.loader = false
          if (response.data.success) {
            //success
            //go to qualification preset list
            this.$router.replace({ name: 'qualification-preset' })
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            //still logged in
            this.errorOutput = this.generalParseErrorArray(response.data.returnData.error_ar)
          }
        })
        .catch(error => {
          this.loader = false
          snackBarBus.$emit('message', error.toString())
        })
    }
  },
  created() {
    //get view data
    let config = {
      headers: {
        'Authorization': this.access_token
      }
    }
    let url = this.url_composeApiUrl('/company/qualification-preset-edit/' + this.id)
    axios.get(url, config)
      .then(response => {
//        console.log(url + ' response', response)
        this.loader = false
        if (response.data.success) {
          //success
          this.viewData = response.data.returnData.viewData
          this.viewDataIsLoaded = true
        } else if (this.onNonSuccessApiCall(response.data.returnData)) {
          snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
        }
      })
      .catch(error => {
        this.loader = false
        snackBarBus.$emit('message', error.toString())
      })
  }
}
</script>

<style>

</style>